import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

const RowContainer = styled.div`
  color: hsl(0, 0%, 100%);
  display: flex;
  justify-content: center;
  gap: 5px;

  ${({ theme }) => theme.mediaQueries.sm} {
    gap: 10px;
  }
`

const Heading = styled.h1`
  color: ${({ theme }) => theme.colors.textSubtle};
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;

  ${({ theme }) => theme.mediaQueries.sm} {
    font-size: 18px;
  }
`

const Information = styled.h1`
  color: ${({ theme }) => theme.colors.text};
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;

  ${({ theme }) => theme.mediaQueries.sm} {
    font-size: 18px;
    line-height: 26px;
  }
`

const Item = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 64px;
  height: 64px;

  background: ${({ theme }) => theme.colors.input};
  border-radius: 6px;
`

const ItemValue = styled.span`
  color: ${({ theme }) => theme.colors.text};
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 8px;

  ${({ theme }) => theme.mediaQueries.sm} {
    font-size: 20px;
  }
`
const ItemLabel = styled.p`
  color: ${({ theme }) => theme.colors.text};
  font-size: 12px;
  margin-bottom: 3px;
  letter-spacing: 0;
  line-height: 0;

  ${({ theme }) => theme.mediaQueries.sm} {
    font-size: 13px;
  }
`

const StyledCard = styled.div`
  align-self: baseline;
  // background: linear-gradient(99.32deg, #FF7A00 -1.35%, #FFFFFF 27.14%, #FFFFFF 84.61%, #FF7A00 130.68%);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  position: relative;
  text-align: center;
  margin-bottom: 24px;
`

const Wrapper = styled.div`
  padding: 16px;
  border: 1px solid ${({theme}) => theme.colors.disabled};
  border-radius: 8px;
`

const LockTimer: React.FC<{ currentTime: number; lockAt: number; duration: number; unlocked: boolean }> = ({ currentTime, lockAt, duration, unlocked }) => {
  const [title, setTitle] = useState('')
  const [days, setDays] = useState(0)
  const [hours, setHours] = useState(0)
  const [minutes, setMinutes] = useState(0)
  const [seconds, setSeconds] = useState(0)
  const [ended, setEnded] = useState(false)

  useEffect(() => {
    if (unlocked) {
      setTitle('Tokens were unlocked by locker.')
      setEnded(true)
    } else if (currentTime >= lockAt + duration) {
      setEnded(true)
      setTitle('Lock finished. Locker can unlock tokens.')
    } else {
      setTitle('Lock finishes in')
      const delta = lockAt + duration - currentTime
      
      setDays(Math.floor(delta / (60 * 60 * 24)))
      setHours(Math.floor(delta / (60 * 60)) % 24)
      setMinutes(Math.floor(delta / 60) % 60)
      setSeconds(Math.floor(delta % 60))
    }
  }, [currentTime, lockAt, duration, unlocked])

  return !ended ? (
    <StyledCard>
      <Heading>{title}</Heading>
      <RowContainer>
        <Item>
          <ItemValue id="days">{ended ? '—' : days.toLocaleString('en-US', { minimumIntegerDigits: 2 })}</ItemValue>
          <ItemLabel>Days</ItemLabel>
        </Item>
        <Item>
          <ItemValue id="days">{ended ? '—' : hours.toLocaleString('en-US', { minimumIntegerDigits: 2 })}</ItemValue>
          <ItemLabel>Hours</ItemLabel>
        </Item>
        <Item>
          <ItemValue id="days">{ended ? '—' : minutes.toLocaleString('en-US', { minimumIntegerDigits: 2 })}</ItemValue>
          <ItemLabel>Minutes</ItemLabel>
        </Item>
        <Item>
          <ItemValue id="days">{ended ? '—' : seconds.toLocaleString('en-US', { minimumIntegerDigits: 2 })}</ItemValue>
          <ItemLabel>Seconds</ItemLabel>
        </Item>
      </RowContainer>
    </StyledCard>
  ) : <Wrapper><Information>{title}</Information></Wrapper>
}

export default LockTimer
